import type { AxiosInstance } from 'axios'
import { ApiEndpoint } from '../../../../shared/api-endpoint'
import { downloadBlob } from '../../../../shared/helpers/download-blob'

export const ReportType = {
  FreeUsers: 'free_users',
  FreeSubscribers: 'free_subscribers',
  IncompleteSignups: 'incomplete_signups',
  ChurnedSubscribers: 'churned_subscribers',
  BronzeSubscribers: 'bronze_subscribers',
  GoldSubscribers: 'gold_subscribers',
  FreeGoldUpgrades: 'free_gold_upgrades',
  BronzeGoldUpgrades: 'bronze_gold_upgrades',
  UserEngagementIos: 'user_engagement_ios',
  UserEngagementWebTop1Percent: 'user_engagement_web_top_1_percent',
  UserEngagementWebTop10Percent: 'user_engagement_web_top_10_percent',
  AnnualGiftEligibleSubscribers: 'annual_gift_eligible_subscribers',
  PaidSubscribersDetail: 'paid_subscribers_detail',
  MemberStatus: 'member_status'
} as const

export type ReportType = (typeof ReportType)[keyof typeof ReportType]

export const ALL_REPORT_TYPES: ReportType[] = Object.values(ReportType)

export class DownloadReportsInteractor {
  constructor(
    private readonly baseUrl: string,
    private readonly axios: AxiosInstance
  ) {}

  public async execute(organization: string, reports: ReportType[] = ALL_REPORT_TYPES): Promise<void> {
    const params = new URLSearchParams()
    params.set('organization', organization)
    for (const report of reports) {
      params.append('report', report)
    }

    const url = `${this.baseUrl}/${ApiEndpoint.Reports}?${params.toString()}`
    const response = await this.axios.get<Blob>(url, { responseType: 'blob' })

    const contentType = String(response.headers['content-type'] ?? '')
    const filename = contentType.includes('zip') ? 'reports.zip' : 'reports.csv'

    downloadBlob(response.data, filename)
  }
}
